export function getSchoolID() {
  return JSON.parse(localStorage.getItem("user")).school_id;
}

export function getUser() {
  return JSON.parse(localStorage.getItem("user"));
}
export function ctyun_oss() {
  return JSON.parse(localStorage.getItem("ctyun_oss"));
}
export function aliyun_oss() {
  return JSON.parse(localStorage.getItem("aliyun_oss"));
}
